/* eslint-disable no-underscore-dangle */
class ChangePhasePopupController {
	constructor($log, $timeout, loadingIndicatorService, appI18n, appConfig, $stateParams, $q,
		notificationService, signatureService, clinicalDataService, eproService) {
		'ngInject';
		this.$log = $log;
		this.$timeout = $timeout;
		this.$stateParams = $stateParams;
		this.loadingIndicatorService = loadingIndicatorService;
		this.notificationService = notificationService;
		this.signatureService = signatureService;
		this.clinicalDataService = clinicalDataService;
		this.eproService = eproService;
		this.appI18n = appI18n;
		this.appConfig = appConfig;
		this.$q = $q;
		this.isLoading = false;
		this.$API = null;
		this.changePhaseForm = null;
		this.state = null;
		this.errors = {
			genericError: false
		};
		this.sponsorSiteId = null;
		this.subjectKey = null;
		this.subjectStatus = null;
		this.technicalSubjectId = null;
		this.studyId = null;
		this.subjectId1 = null;
		this.countryId = null;
		this.siteId = null;
		this.subjectId = null;
		this.protocolSetupLabels = [];
		
	}

	$onInit() {

		this.$API = this.setApi();
		this.componentReady && this.componentReady({ $API: this.$API });

		if (this.$stateParams.signKey) {
			const state = this.signatureService.getState(this.$stateParams.signKey);

			if (state) {
				if (state.sigType === this.getSignatureType()) {
					if (this.signatureService.checkSignatureWorkflow(this.$stateParams.signKey,
						this.$stateParams.tokenId,
						this.doSubmit, this.onSignatureCancel, this)) {
						return;
					}
				}
			}
		}

		
	}

	setApi() {
		const $API = {
			open: (countryId, siteId, subjectId, subjectKey) => {
				
				this.loadingIndicatorService.show();
				this.countryId = countryId;
				this.siteId = siteId;
				this.subjectId = subjectId;
				this.subjectKey = subjectKey;
				this.appI18n.translate([

				'clinicaldata.subject-in-vocabulary',
				'clinicaldata.change-phase-title'

				]).then((translations) => {
					this.translations = translations;
					this.subjectsTitle = translations['clinicaldata.subject-in-vocabulary'];
					this.popupHeading = translations['clinicaldata.change-phase-title'];
				});
				const oDataQuery = `$filter=contains(SubjectKey,'${this.subjectKey}')&$orderby=SubjectKey&$top=30`;
				const subjectDataPromise = this.clinicalDataService.getSubjects(countryId, siteId, oDataQuery);
				const protocolSetupLabelsPromise = this.eproService.getProtocolSetupLabels();

				this.$q.all([subjectDataPromise, protocolSetupLabelsPromise]).then((responses) => {
				const subjectDataResponse = responses[0];
				const rawLabels = responses[1].data;
				const protocolSetupLabels = [
					rawLabels.find(l => l.fieldKey === 'IT_9')?.dfcLabel,
					rawLabels.find(l => l.fieldKey === 'PAT_SUBJECTID')?.dfcLabel
				].filter(Boolean);
				this.protocolSetupLabels = protocolSetupLabels;
				this.subjectContext = subjectDataResponse.data;
				// Enable submit button if nextPhaseAbbreviation is one of the allowed phases
				this.submitButtonDisabled = true;
                const allowedPhases = ['Included', 'Randomized', 'TreatmentPeriodCompleted'];
                const nextPhase = this.subjectContext[0].nextPhaseAbbreviation;
				this.siteId = this.subjectContext[0].siteId;
				this.subjectKey = this.subjectContext[0].subjectId;
				this.technicalSubjectId = this.subjectContext[0].technicalSubjectId;
				this.subjectId1 = this.subjectContext[0].subjectKey;
				this.subjectStatus = nextPhase
				this.subjectPTSValue = this.subjectContext[0].patientStateValue;
				this.submitButtonDisabled = !allowedPhases.includes(nextPhase) || (this.subjectContext[0].currentPhaseAbbreviation != this.subjectContext[0].patientStateValue);
				// ACTION BUTTONS
				this.submitBtn = {
					action: () => {
						this.initiateSignature();
					},
					cssClass: '-es-primary',
					displayName: 'app.buttons.sign-submit',
					isDisabled:  this.submitButtonDisabled,
					type: 'submit'
				};
				this.cancelBtn = {
					action: () => {
						this.cancelAction();
					},
					displayName: 'app.buttons.cancel',
					isDisabled: false
				};	
					this.actions = [this.submitBtn, this.cancelBtn];
					this.open = true;
					this.$timeout(() => {
						const placeholderEl = angular.element(document).find('#device-action-change-phase-placeholder');
						this.deviceActionWidgetEl = angular.element('<device-action-phase-change  />');
						this.deviceActionWidgetEl[0].addEventListener('formDataChange', (event) => {
							const formData = event.detail;
							this.formData = formData;
						  });					
						this.deviceActionWidgetEl[0].siteIds = [this.subjectContext[0].sponsorSiteId];
						this.deviceActionWidgetEl[0].subjectIds = [subjectKey];
						this.deviceActionWidgetEl[0].currentPhase = this.subjectContext[0].currentPhaseAbbreviation;
						this.deviceActionWidgetEl[0].nextPhase = this.subjectContext[0].nextPhaseAbbreviation;
						this.deviceActionWidgetEl[0].randomizationCriteria = this.subjectContext[0].randomizationCriteria;
						this.deviceActionWidgetEl[0].subject = this.subjectsTitle;
						this.deviceActionWidgetEl[0].subjectPTSValue = this.subjectPTSValue;
						this.deviceActionWidgetEl[0].vocabulary = this.protocolSetupLabels;
						placeholderEl.empty().append(this.deviceActionWidgetEl);
						this.loadingIndicatorService.hide();
					}, 200);
				})
				.catch((error) => {
					this.loadingIndicatorService.hide();
					this.notificationService.error('Error loading data');
				});
				},
			close: () => {
				this.open = false;
			}
		};
		return $API;
	}

	cancelAction() {
		this.$API.close();
	}
	close() {
		this.deviceActionWidgetEl[0].showClosingSpinner = true;
		this.deviceActionWidgetEl[0].showInfoBox = false;
	}

	saveAction() {
		if (this.changePhaseForm.$invalid) {
			this.changePhaseForm.$setDirty();
			return;
		}

		this.isLoading = true;
		// TODO: Implement save logic
		this.$log.log('Save action triggered');
		this.isLoading = false;
	}

	isSaveDisabled() {
		return this.changePhaseForm && this.changePhaseForm.$invalid;
	}

	$onDestroy() {
		this.$log.log('ChangePhasePopupController destroyed');
	}

	initiateSignature() {
		
		if (this.deviceActionWidgetEl && this.deviceActionWidgetEl[0] && this.deviceActionWidgetEl[0].showAdditionalDialog) {
			this.deviceActionWidgetEl[0].showAdditionalDialog = false;
			this.proceedWithSignature();
			return;
		}
        
		const isRandomizedPhase = this.subjectStatus === 'Randomized';
		const isRandomizationCriteriaNotMet = this.subjectContext[0].randomizationCriteria === 'Not Met';
		
		if (isRandomizedPhase && isRandomizationCriteriaNotMet) {
			if (this.deviceActionWidgetEl && this.deviceActionWidgetEl[0]) {
				this.deviceActionWidgetEl[0].showAdditionalDialog = true;
				return;
			}
		}
		
		this.proceedWithSignature();
	}
	
	proceedWithSignature() {
		const sigType = this.getSignatureType();

		// save state for signature process
		this.state = {
			subjectStatus: this.subjectStatus,
			technicalSubjectId: this.technicalSubjectId,
			subjectId1: this.subjectId1,
			siteId: this.siteId,
			countryId: this.countryId,
			subjectKey: this.subjectKey,
			sigType,
		};

		this.additionalInfo = {
			action: this.appI18n.translateImmediate(
						'signature.action.changePhase'
				  ),	
			infoKey2: this.appI18n.translateImmediate('signature.info.subject'),
			infoValue2: this.subjectId1,
		};

		this.signatureService.sign(sigType, this.additionalInfo, this.state);
	}
	
	getSignatureType() {
		return this.appConfig.sigType.changePhase;
	}

	getEditSubjectInfo(countryId, siteId, subjectId) {
		return this.subjectManagerService.getEditSubjectData(countryId, siteId, subjectId).then((res) => {
			return res.data;
		});
	}

	doSubmit(state) {
		const action = this.chooseSubmitAction(state);

		if (!action) {
			return;
		}

		this.loadingIndicatorService.show();
		action.then((resp) => {
			if (resp.data.isValidationError) {
				const msg = (resp.data && resp.data.responseMessageTranslationKey)
					  ? resp.data.responseMessageTranslationKey
					  : 'clinicaldata.subject.create.errors.genericSaveError';
				this.notificationService.showError(this.appI18n.translateImmediate(msg));
				this.open = true;
			} else {
				const messageKey = 'clinicaldata.subject.create.saveDelayUpdate';
				this.showSaveUpdateDelayWarning(messageKey);
			}
		}, (/*error*/) => {
			this.open = true;
		}).finally(() => {
			this.loadingIndicatorService.hide();
		});
	}

	showSaveUpdateDelayWarning(messageKey) {
		this.appI18n.translate([messageKey]).then((translations) => {
			const msg = translations[messageKey];
			this.notificationService.showSuccess(msg);
		});
	}

	chooseSubmitAction(state) {
		let action = null;
		const payload = this.generateRequestPayload(state);
		action = this.clinicalDataService.changeSubjectPhase(payload, state.technicalSubjectId, state.subjectStatus);
		return action;
	}

	onSignatureCancel(state) {
		this.$timeout(() => {
			this.open = true;
			this.restorePopupState(state);
		});
	}

	generateRequestPayload(state) {
		const payload = {
			signKey: this.$stateParams.signKey,
			signToken: this.$stateParams.tokenId,
			subjectId1: state.subjectId1,
			siteId: state.siteId
		};
		return payload;
	}

	restorePopupState(state) {
		this.$API.open(state.countryId, state.siteId, state.subjectKey, state.subjectId1);
	}
}

export default ChangePhasePopupController;
